module.exports = __webpack_public_path__ + "img/learnupskill.43af53a5.svg";